var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var PipePostRequest_1;
import { JSON, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import '@symon-ai/wisepipe-base-pipe'; // force import
import { EngineMode, Pipe, CONTENT_MAX_LENGTH } from '@symon-ai/wisepipe-base-pipe';
import { pipePostRequestSchemaValidation } from '../validations.generated';
export const pipePostRequestSchema = {
    $id: 'urn:wisepipe-common-pipe:PipePostRequest',
    type: 'object',
    properties: {
        name: { type: 'string', minLength: 1, maxLength: Pipe.NAME_MAX_LENGTH },
        engineMode: { type: 'string', enum: Object.values(EngineMode) },
        copyOrgID: { type: 'string', format: 'uuid' },
        copyID: { type: 'string', uid: 10 },
        copyVersionID: { type: 'string', uid: 10 },
        description: { type: 'string', maxLength: 1000 },
        documentation: { type: 'string', minLength: 1, maxLength: CONTENT_MAX_LENGTH },
        image: { type: 'string', maxLength: 1024 },
        challengeData: { $ref: 'urn:wisepipe-base-pipe:ChallengeData' }
    },
    required: ['name', 'engineMode'],
    allOf: [
        {
            // copyOrgID is only valid with a copyID
            if: { required: ['copyOrgID'] },
            then: { required: ['copyID'] }
        },
        {
            // for copying from a previous version of a pipe. copyVersionID is only valid with a copyID
            if: { required: ['copyVersionID'] },
            then: { required: ['copyID'] }
        }
    ]
};
let PipePostRequest = PipePostRequest_1 = class PipePostRequest {
    constructor(name, engineMode, copyOrgID, copyID, description, documentation, image, challengeData, copyVersionID) {
        this.name = name;
        this.engineMode = engineMode;
        // Copy?
        if (copyID) {
            Pipe.validate(copyID);
            this.copyID = copyID;
        }
        if (copyOrgID)
            this.copyOrgID = copyOrgID;
        if (description)
            this.description = description;
        if (documentation)
            this.documentation = documentation;
        if (image)
            this.image = image;
        if (challengeData)
            this.challengeData = challengeData;
        if (copyVersionID)
            this.copyVersionID = copyVersionID;
        JSON.validate(this, PipePostRequest_1);
    }
};
PipePostRequest = PipePostRequest_1 = __decorate([
    JsonSchemaV2(pipePostRequestSchema, pipePostRequestSchemaValidation)
], PipePostRequest);
export { PipePostRequest };
//# sourceMappingURL=pipePostRequest.js.map